import { useNavigate } from "react-router-dom";
import { useTemplate } from "@utils/useTemplate";
import { UseFormReturn } from "react-hook-form";

interface TemplatePayload {
  name: string;
  description: string;
  prompt: string;
  template_type: string | null;
  company_id?: number | null;
}

interface SaveTemplateOptions {
  templateId?: string;
  isChoosing?: boolean;
  projectId?: string;
  reportName?: string;
  checkedItems?: any;
  returnUrl?: string;
}

const useHandleSaveTemplate = (
  options: SaveTemplateOptions,
  methods: UseFormReturn<
    {
      templateName: string;
      templateDescription: string;
      templatePrompt: string;
      templateType: string;
    },
    any,
    {
      templateName: string;
      templateDescription: string;
      templatePrompt: string;
      templateType: string;
    }
  >
) => {
  const navigate = useNavigate();
  const { saveTemplate } = useTemplate();

  const handleSaveTemplate = async (
    payload: TemplatePayload,
    setSubmitting: (value: React.SetStateAction<boolean>) => void
  ) => {
    try {
      setSubmitting(true);
      await saveTemplate(payload, {
        templateId: options.templateId,
        isChoosing: options.isChoosing,
        projectId: options.projectId,
        reportName: options.reportName,
        checkedItems: options.checkedItems,
      });

      if (options.isChoosing) {
        methods.reset(methods.getValues());
        setTimeout(() => {
          if (options.returnUrl)
            navigate(options.returnUrl, {
              state: {
                projectId: options.projectId,
                reportName: options.reportName,
                checkedItems: options.checkedItems,
              },
            });
        }, 500);
      } else {
        methods.reset(methods.getValues());
        setTimeout(() => {
          navigate("/templates");
          setSubmitting(false);
        }, 500);
      }
    } catch (error) {
      console.error("Error saving template:", error);
      setSubmitting(false);
    }
  };

  return handleSaveTemplate;
};

export default useHandleSaveTemplate;
